import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Dashboard from "../../pages/Dashboard/Dashboard";
import {
  appInsights,
  reactPlugin,
  browserHistory,
} from "../../utils/appInsights"; // Import App Insights setup
import { withAITracking } from "@microsoft/applicationinsights-react-js"; // For tracking components
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js"; // For Application Insights Context
import AuthCallback from "./AuthCallback";
import Logout from "../../hooks/logout";

const DashboardWithTracking = withAITracking(reactPlugin, Dashboard);

export const AppRouter: React.FC = () => {
  const isAuthenticated = !!localStorage.getItem("accessToken");

  const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
    const isAuthenticated = !!localStorage.getItem("access_token");
    const navigate = useNavigate();
  
    useEffect(() => {
      if (!isAuthenticated) {
        navigate('/logout');
      }
     
    }, [isAuthenticated, navigate]);
  
    if (isAuthenticated) {
      return children;
    }
    return null;
  };
  return (
    <BrowserRouter>
      <Routes>
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardWithTracking />
            </ProtectedRoute>
          }
        />
                <Route path="/logout" element={<Logout />} />

      </Routes>
    </BrowserRouter>
  );
};
